import * as React from "react";
import {Box, Collapse, Typography} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {EmptyDocumentsTab} from "./DocumentsEmptyStates";

function ExpandableDocumentCards({rows, columns, columnsRenderer, renderDetail, emptyLabel, expandedRowIds, onToggleRow}) {
    const CARDS_MINIMUM_WIDTH = 960;

    const cellContentOf = (row, column) => {
        return columnsRenderer[column.id] ? columnsRenderer[column.id](row) : row[column.id];
    }

    if (rows.length === 0) {
        return <EmptyDocumentsTab label={emptyLabel}/>;
    }

    const [numberColumn, ...remainingColumns] = columns;
    const columnsGrid = {
        display: 'grid', gap: 1, alignItems: 'center', padding: '8px 12px',
        gridTemplateColumns: columns.map(column => column.width).join(' '),
    };
    const justificationOf = (column) => column.align === 'right' ? 'end' : 'start';

    return (
        <Box sx={{overflowX: 'auto'}}>
            <Box sx={{minWidth: CARDS_MINIMUM_WIDTH}}>
                <Box sx={columnsGrid}>
                    {columns.map(column =>
                        <Typography key={column.id} component="div" color="text.secondary" sx={{
                            justifySelf: justificationOf(column), textTransform: 'uppercase',
                            fontSize: '10.5px', letterSpacing: '0.03em', fontWeight: 700,
                        }}>
                            {column.label}
                        </Typography>
                    )}
                </Box>
                {rows.map(row => {
                    const rowIsExpanded = expandedRowIds.has(row.id);
                    return (
                        <Box key={row.id} sx={{border: '1px solid', borderColor: 'divider', borderRadius: 1, mb: 1, overflow: 'hidden'}}>
                            <Box onClick={() => onToggleRow(row.id)} sx={{
                                ...columnsGrid, backgroundColor: 'background.default', cursor: 'pointer',
                            }}>
                                <Box display="flex" alignItems="center" gap={0.5} sx={{justifySelf: justificationOf(numberColumn)}}>
                                    <ChevronRightIcon fontSize="small" sx={{
                                        color: 'text.disabled', transition: 'transform .12s ease',
                                        transform: rowIsExpanded ? 'rotate(90deg)' : 'none',
                                    }}/>
                                    {cellContentOf(row, numberColumn)}
                                </Box>
                                {remainingColumns.map(column =>
                                    <Typography key={column.id} component="div" variant="body2" sx={{justifySelf: justificationOf(column)}}>
                                        {cellContentOf(row, column)}
                                    </Typography>
                                )}
                            </Box>
                            <Collapse in={rowIsExpanded} timeout="auto" unmountOnExit>
                                {renderDetail(row)}
                            </Collapse>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}

export default ExpandableDocumentCards;
